module.exports = "/images/start-collect-customer-data.svg?ac04d50e11f13aaab4f5b6c73976a05e";